class APIMock {
  constructor() {
    this.data = [
      {
        message_type: "MESSAGE",
        data: {
          sender: { id: "bot" },
          text: "Let's resume our session.",
          id: "welcome",
        },
      },
      {
        message_type: "MESSAGE",
        data: {
          sender: { id: "bot" },
          status: "typing",
          text: "",
          thinking: true,
          id: "/sample-insurance/eng/9",
        },
      },
      {
        message_type: "MESSAGE",
        data: {
          sender: { id: "bot" },
          text: "What is your insurance and policy name?",
          subtext: "",
          format: "module_insurance_policy",
          icon: "",
          values: {
            sender: { id: "bot" },
            id: "/sample-insurance/eng/9/0",
            values: {},
            continue: false,
            showDefaultUI: true,
            showDefaultInput: true,
            text: "Let's see if we can find your primary insurance carrier.",
            subtext: "Tap here to Type and we will search for you.",
            format: "autocomplete",
          },
          id: "/sample-insurance/eng/9",
          showDefaultInput: true,
          showDefaultUI: true,
          progress: 27.2,
        },
      },
    ];

    this.callback = null;
  }

  initiate() {
    const _self = this;

    let timerId = setInterval(function() {
      const lastReq = _self.data.shift();
      if (lastReq) {
        _self.callback && _self.callback(lastReq.data);
      } else {
        console.log("no data");
      }
    }, 1000);
  }

  on(message_type, callback) {
    if (message_type === "MESSAGE") {
      this.callback = callback;
    }
  }

  emit(message_type, data, cb) {
    console.log(message_type, data, cb);
    const possibleAnswers = ["United Health", "Rock", "Paper", "Scissor"];
    const response = [];
    for (var i = 0; i < 100; i++) {
      response.push({
        name: possibleAnswers[Math.floor(Math.random() * possibleAnswers.length)],
      });
    }

    if (data.answer.reference === "medication" && data.answer.typing.length > 0) {
      this.data.push({
        message_type: "MESSAGE",
        data: {
          _id: "/sample-insurance/eng/9",
          format: "module_insurance_policy",
          id: "/sample-insurance/eng/9",
          sender: { id: "bot" },
          values: {
            id: "/sample-insurance/eng/9/0",
            typing: data.answer.typing,
            isPickOnly: true,
            suggestions: response,
          },
          continue: false,
          showDefaultUI: true,
          showDefaultInput: true,
        },
      });
    } else if (typeof data.answer === "string") {
      this.data.push({
        message_type: "MESSAGE",
        data: {
          sender: { id: "bot" },
          status: "typing",
          text: "",
          thinking: true,
          id: "/sample-insurance/eng/9",
        },
      });
      this.data.push({
        message_type: "MESSAGE",
        data: {
          sender: { id: "bot" },
          format: "module_insurance_policy",
          values: { id: "/sample-insurance/eng/9/answer/0", text: "TES" },
          id: "/sample-insurance/eng/9",
          showDefaultInput: false,
          showDefaultUI: true,
          progress: 27.2,
        },
      });
      this.data.push({
        message_type: "MESSAGE",
        data: {
          sender: { id: "bot" },
          format: "module_insurance_policy",
          values: {
            sender: { id: "bot" },
            id: "/sample-insurance/eng/9/1",
            values: "PPO|HMO|EPO|unsure|other",
            continue: false,
            showDefaultUI: true,
            showDefaultInput: true,
            text: "What type of primary insurance is it?",
            subtext: "",
            format: "singleselect",
          },
          id: "/sample-insurance/eng/9",
          showDefaultInput: true,
          showDefaultUI: true,
          progress: 27.2,
        },
      });
    }
  }
}

module.exports = new APIMock();
